import { memo } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import TableCell from '@mui/material/TableCell';
import useQueryParams from '../hooks/useQueryParams';
import HighlightedText from './HighlightedText';

export const TableCellTypography = styled(Typography)(({ theme }) => ({
  color: '#DDDDDD',
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(12),
  wordBreak: 'break-word',
  lineHeight: '22px',
  '& .highlight': {
    backgroundColor: '#7DFF92',
    color: 'black',
    fontWeight: 'bold',
    padding: '0 2px',
  },
}));

const formatTableCell = (value, isNumber) => {
  return !!value ? value : isNumber ? 0 : '-';
};

const GenericTableCell = ({
  value,
  isNumber,
  styles = {},
  highlightText = true,
  /** When set (including empty string), used for match highlighting instead of URL search */
  searchValue: searchValueProp,
  ...props
}) => {
  const {
    queryObject: { searchValue: urlSearchValue },
  } = useQueryParams();

  const effectiveSearch = searchValueProp !== undefined ? searchValueProp : urlSearchValue;

  return (
    <TableCell {...props} sx={{ color: 'inherit' }}>
      <TableCellTypography sx={{ ...styles }}>
        {highlightText && typeof value === 'string' ? (
          <HighlightedText
            text={value}
            searchValue={effectiveSearch}
            fallback={formatTableCell(value, isNumber)}
          />
        ) : (
          formatTableCell(value, isNumber)
        )}
      </TableCellTypography>
    </TableCell>
  );
};

export default memo(GenericTableCell);
